import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../components/Button/Button'

export const GetIntegrationButton = ({
  className,
  integrationWebsiteUrl,
}: {
  className?: string
  integrationWebsiteUrl: string
}) => {
  const hasPathname = () => {
    try {
      const url = new URL(integrationWebsiteUrl)
      return url.pathname.length > 1
    } catch {
      return false
    }
  }

  const isDisabled = !hasPathname()

  return (
    <Button
      variant="primary"
      disabled={isDisabled}
      size="huge"
      rel="noopener noreferrer"
      href={integrationWebsiteUrl}
      onClick={(event) => {
        if (isDisabled) {
          event.preventDefault()
        }
      }}
      className={classNames('width-full margin-bottom-40', className)}
    >
      {isDisabled ? (
        <FormattedMessage
          id="integration.page.visitWebsiteButton.disabled"
          defaultMessage="Built-in"
        />
      ) : (
        <FormattedMessage
          id="integration.page.visitWebsiteButton"
          defaultMessage="Add to Slite"
        />
      )}
    </Button>
  )
}
